import { useEffect, useState } from 'react'
import { Container, Row, Col, Modal, Button, Card } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from 'react-redux'
import { useAuth } from '../../components/auth/useAuth'
import { getFarms, addFarm, editFarm } from '../../actions/other/farmsActions'
import { getUsers, getForSelect } from '../../actions/auth/usersActions'
import { CustomDataTable } from '../../components/design/Datatables/CustomDataTable'
import Swal from 'sweetalert2'
import Loader from '../../components/loaders/Loader'
import FarmForm from '../../components/forms/FarmForm'

export default function Farms() {
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const {clientauth} = useAuth()

    const [page, setPage] = useState(1)
    const [limit, setLimit] = useState(25)
    const [search, setSearch] = useState('')
    const [searchAux, setSearchAux] = useState('')
    const [totalRows, setTotalRows] = useState(0)

    const {farm, farms, resultfarm, loading, total} = useSelector(state=>state.farms)
    const {breeders, technicians} = useSelector(state=>state.users)

    const [modalShow, setModalShow] = useState(false)
    const [formState, setFormState] = useState({})
    const [isRegistering, setIsRegistering] = useState(false)
    const [isAddingOrEditing, setIsAddingOrEditing] = useState(false)

    useEffect(() => {
        if(clientauth){
            dispatch(getFarms(page, limit, search))
            dispatch(getForSelect())
        }
    },[dispatch, t, clientauth])

    useEffect(() => {
        if (clientauth) {
            dispatch(getFarms(page, limit, search))
        }
    }, [page, limit, search])

    const openModal = () =>{
        setIsAddingOrEditing('adding')
        setFormState({})
        setModalShow(true)
    }

    const selectFarm = (farm) => {
        setFormState({
            ...farm,
            technicians: farm.technicians.map(t => t._id)
        })
        setIsAddingOrEditing('editing')
        setModalShow(true)
    }

    const handleInputChange = ({target})=>{
        setFormState({
            ...formState,
            [target.name]: target.value
        })
    }

    const handleSubmit= async(e) => {
        e.preventDefault()
        setIsRegistering(true)

        if(isAddingOrEditing==='editing'){
            dispatch(editFarm(formState, formState._id))
        }else{
            dispatch(addFarm(formState))
        }
        setIsRegistering(false)
    }

    useEffect(() => {
        if(resultfarm){
            let resultfarmnow = resultfarm
            dispatch({ type: 'FARM_RESET_RESULT' })
            switch (resultfarmnow) {
                case 'success':
                    dispatch(getFarms(page, limit, search))
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('admin.farm.addsuccess')
                    }).then(() => {
                        setModalShow(false)
                        setIsAddingOrEditing(false)
                    })
                    break;
                case 'needMoreData':
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.ok'),
                        icon: 'warning',
                        text: t('admin.farm.needMoreData')
                    })
                    break;
                case 'editSuccess':
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('admin.farm.editSuccess')
                    }).then(() => {
                        setModalShow(false)
                        setIsAddingOrEditing(false)
                    })
                    break;
                default:
                    break;
            }
        }
    // eslint-disable-next-line
    }, [resultfarm])

    const columnsFarm = [
        {
            name: t('admin.farm.name'),
            cell: farm =>
                <div className='cursor' onClick={() => selectFarm(farm)}>
                    {farm.name}
                </div>,
            selector: (farm) => farm.name,
            sortable: true,
        },{
            name: t('admin.farm.regaCode'),
            cell: farm =>
                <div className='cursor' onClick={() => selectFarm(farm)}>
                    {farm.regaCode}
                </div>,
            selector: (farm) => farm.regaCode,
            sortable: true,
        },{
            name: t('admin.farm.sigCoordinates'),
            cell: farm =>
                <div className='cursor' onClick={() => selectFarm(farm)}>
                    {farm.sigCoordinates}
                </div>,
            selector: (farm) => farm.sigCoordinates,
            sortable: true,
        },{
            name: t('admin.farm.breeder'),
            cell: farm =>
                <div className='cursor' onClick={() => selectFarm(farm)}>
                    {farm.breeder?.name}
                </div>,
            selector: (farm) => farm.breeder?.name,
            sortable: true,
        },{
            name: t('admin.farm.technicians'),
            cell: farm => (
                <div className='cursor' onClick={() => selectFarm(farm)}>
                    {Array.isArray(farm.technicians)
                        ? farm.technicians.map(t => t?.name || '').join(', ')
                        : ''}
                </div>
            ),
            sortable: true,
        },{
            name: '',
            width: '100px',
            cell: farm =>
                <div className='cursor' onClick={() => selectFarm(farm)}>
                    <i className='fas fa-pencil'></i>
                </div>,
            sortable: false,
        }
    ]

    return (
        <Container className='p-5'>
            <Row>
                <Col xs={12}>
                    <h1>{t('admin.farm.farms')}</h1>
                </Col>
                <Col xs={12} className='d-flex justify-content-end'>
                    <Button variant='primary' type="submit" className="my-2 cursor" onClick={() => openModal()}>
                        <i className="fas fa-plus me-2"></i>  {t('admin.farm.createfarm')}
                    </Button>
                </Col>
            </Row>
            <Row>
                <Col xs={12} className='my-3'>
                    {loading ?
                        <Loader/>
                    :
                        <Row>
                            <Col>
                                <Card>
                                    <Card.Body>
                                        <div className="d-flex my-2">
                                            <input
                                                type="text"
                                                className="form-control me-2"
                                                placeholder={t("datatables.buscar")}
                                                value={searchAux || ""}
                                                onChange={e => {
                                                    setSearchAux(e.target.value);
                                                    setPage(1);
                                                }}
                                                onKeyDown={(e) => {if (e.key === 'Enter') { setSearch(searchAux); setPage(1); }}}
                                            />
                                            <Button onClick={() => setSearch(searchAux)}><i className='fas fa-search'></i></Button>
                                        </div>
                                        {farms?.length > 0 ?
                                            <CustomDataTable
                                                columns={columnsFarm}
                                                data={farms}
                                                pagination
                                                paginationServer
                                                paginationTotalRows={totalRows}
                                                searchText={search}
                                                onChangeRowsPerPage={(newLimit, page) => {
                                                    if (limit !== newLimit) {
                                                        setLimit(newLimit)
                                                        setPage(1)
                                                    }
                                                }}
                                                onChangePage={(newPage) => {
                                                    setPage(newPage)
                                                }}
                                            />
                                        :
                                            <h4 className='mt-4'>{t('admin.farm.thereisnotfarm')}</h4>
                                        }
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    }
                </Col>
            </Row>
            <Modal
                show={modalShow}
                onHide={() => setModalShow(false)}
                aria-labelledby="contained-modal-title-vcenter"
                size="lg"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        <h2>{t('admin.farm.farm')}</h2>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <FarmForm
                        state={formState}
                        farmtype={'admin'}
                        handleInputChange={handleInputChange}
                        submit={handleSubmit}
                        isAddingOrEditing={isAddingOrEditing}
                        isRegistering={isRegistering}
                        breederOptions={breeders}
                        technicianOptions={technicians}
                    />
                </Modal.Body>
            </Modal>
        </Container>
    )
}